"use client";

import { ConnectButton } from '@rainbow-me/rainbowkit';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import { setUserAuth } from '@/redux/features/userAuth/userAuthSlice';
import { UserAuthProps } from '@/types/types';
import './clientLayout.styles.scss';

export const ConnectWallet = () => {

  const dispatch = useDispatch();
  
  const handleWalletConnect = (walletData: UserAuthProps) => {
    // Convert Date objects to ISO strings for serialization
    const serializedWalletData = {
      ...walletData,
      connectionTimestamp: walletData.connectionTimestamp.toISOString(),
      userAuthCreatedAt: walletData.userAuthCreatedAt.toISOString(),
    };

    dispatch(setUserAuth(serializedWalletData));
  };

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus ||
            authenticationStatus === 'authenticated');
        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <button onClick={openConnectModal} type="button" className='connect-wallet-btn'>
                    Connect Wallet
                  </button>
                );
              }
              if (chain.unsupported) {
                return (
                  <button onClick={openChainModal} type="button">
                    Wrong network
                  </button>
                );
              }

              if (connected) {
                const walletData: UserAuthProps = {
                  userAuthId: account.address,
                  walletAddress: account.address,
                  chainId: chain.id,
                  balance: account.displayBalance || '0',
                  connector: 'RainbowKit',
                  connectionTimestamp: new Date(),
                  browserUserAgent: navigator.userAgent,
                  connectionMethod: 'RainbowKit',
                  userAuthCreatedAt: new Date(),
                };

                handleWalletConnect(walletData);
              }

              return (
                <div style={{ display: 'flex', gap: 20 }}>
                  <button
                    onClick={openChainModal}
                    style={{ display: 'flex', alignItems: 'center' }}
                    type="button"
                    className='connected-wallet-network-btn'
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          width: 20,
                          height: 20,
                          borderRadius: 999,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <Image
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            width={20}
                            height={20}
                            className='connect-wallet-network-icon'
                          />
                        )}
                      </div>
                    )}
                    {chain.name}
                  </button>
                  <button onClick={openAccountModal} type="button" className='connected-wallet-btn'>
                    {account.displayName}
                    {account.displayBalance
                      ? ` (${account.displayBalance})`
                      : ''}
                  </button>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};
